import { render, staticRenderFns } from "./outbound-text-message.vue?vue&type=template&id=b6267e1e"
import script from "./outbound-text-message.vue?vue&type=script&lang=js"
export * from "./outbound-text-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6267e1e')) {
      api.createRecord('b6267e1e', component.options)
    } else {
      api.reload('b6267e1e', component.options)
    }
    module.hot.accept("./outbound-text-message.vue?vue&type=template&id=b6267e1e", function () {
      api.rerender('b6267e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/outbound-text-message.vue"
export default component.exports